export default __webpack_public_path__ + "static/media/cancelledJob.fa4591bf.svg";